import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

export const login = (username, password) => API.post('/auth/login', { username, password }).then(res => res.data);

export const getNews = (limit = 6, offset = 0, archived = false) => 
  API.get(`/news?limit=${limit}&offset=${offset}&archived=${archived}`).then(res => res.data);

// ========== НОВОСТИ ==========
export const getNewsById = (id) => API.get(`/news/${id}`).then(res => res.data);
export const createNews = (formData) => API.post('/news', formData).then(res => res.data);
export const updateNews = (id, formData) => API.put(`/news/${id}`, formData).then(res => res.data);
export const deleteNews = (id) => API.delete(`/news/${id}`).then(res => res.data);

export const archiveNews = (id, isArchived) => API.patch(`/news/${id}/archive`, { isArchived }).then(res => res.data);
export const restoreNews = (id) => API.patch(`/news/${id}/restore`).then(res => res.data);
export const getArchivedNews = (limit = 20, offset = 0) => API.get(`/news?limit=${limit}&offset=${offset}&archived=true`).then(res => res.data);

// ========== КАНДИДАТЫ ==========
export const getCandidates = () => API.get('/candidates').then(res => res.data);
export const getCandidateById = (id) => API.get(`/candidates/${id}`).then(res => res.data);
export const createCandidate = (formData) => API.post('/candidates', formData).then(res => res.data);
export const updateCandidate = (id, formData) => API.put(`/candidates/${id}`, formData).then(res => res.data);
export const deleteCandidate = (id) => API.delete(`/candidates/${id}`).then(res => res.data);

// ========== ГАЛЕРЕЯ ==========
export const uploadGalleryImages = (formData) => API.post('/gallery', formData).then(res => res.data);
export const getGalleryImages = (folder = 'main') => API.get(`/gallery?folder=${folder}`).then(res => res.data);
export const deleteGalleryImage = (id) => API.delete(`/gallery/${id}`).then(res => res.data);
export const moveImageToArchive = (id, folder) => API.put(`/gallery/${id}/move`, { folder }).then(res => res.data);
export const getArchiveFolders = () => API.get('/gallery/folders').then(res => res.data);
export const createArchiveFolder = (name) => API.post('/gallery/folders', { name }).then(res => res.data);
export const deleteArchiveFolder = (id) => API.delete(`/gallery/folders/${id}`).then(res => res.data);

/// ========== СТРАНИЦЫ (Документы, Программа и т.д.) ==========
export const getPageBySlug = (slug) => API.get(`/pages/${slug}`).then(res => res.data);
export const updatePage = (slug, data) => API.put(`/pages/${slug}`, data).then(res => res.data);
export const getAllPages = () => API.get('/pages').then(res => res.data);

// ========== ДОКУМЕНТЫ ==========
export const getDocuments = () => API.get('/documents').then(res => res.data);
export const uploadDocument = (formData) => API.post('/documents', formData).then(res => res.data);
export const deleteDocument = (id) => API.delete(`/documents/${id}`).then(res => res.data);